<template>
  <OurPage :title="$t('title.categories.edit')" :back-route="backRoute" width="md">
    <CategoriesForm ref="categoriesForm" v-model="form" edit-form />

    <CategoriesDeleteModal :category-id="$route.params.id" :show.sync="isShownDeleteModal" />

    <template #footer-left>
      <div class="flex items-center gap-2">
        <OurButton
          v-if="getPermission['catalog_category.update']"
          class="button"
          :text="$t('button.save')"
          @click="onClickSaveButton"
        />

        <OurButton
          class="button"
          :text="$t('button.back')"
          variant="secondary"
          @click="$router.back()"
        />
      </div>
    </template>

    <template #footer-right>
      <OurButton
        v-if="getPermission['catalog_category.delete']"
        class="button"
        variant="thirdary"
        :text="$t('button.delete')"
        @click="onClickDeleteButton"
      />
    </template>
  </OurPage>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import { catalogCategoryQuery } from "./gql/queries";
import { updateCatalogCategoryMutation } from "./gql/mutations";
import CategoriesForm from "../_components/CategoriesForm.vue";
import CategoriesDeleteModal from "../delete/Modal.vue";

export default {
  name: "CategoriesEdit",

  components: {
    CategoriesForm,
    CategoriesDeleteModal,
  },

  mixins: [apolloMixin],

  data() {
    return {
      backRoute: {
        name: "Back",
        title: this.$t("title.categories._"),
      },
      form: {
        name: "",
        sort: 0,
        parentId: null,
        forNotice: false,
        isActive: true,
        linkedProductCategoryIds: [],
      },
      isShownDeleteModal: false,
    };
  },

  computed: {
    ...mapGetters("user", ["getPermission"]),
  },

  created() {
    this.getCategory();
  },

  methods: {
    ...mapActions("catalogCategories", ["refreshCatalogCategories"]),
    ...mapMutations("categories", ["SET_CATEGORY"]),

    async getCategory() {
      const { catalogCategory } = await this.$get(catalogCategoryQuery, {
        categoryId: this.$route.params.id,
      });

      if (catalogCategory) {
        this.form = { ...catalogCategory };
      }
    },

    async onClickSaveButton() {
      if (!this.$refs.categoriesForm.emitForm()) return;

      const { name, isActive, sort, parentId, forNotice, linkedProductCategoryIds } = this.form;

      const { updateCatalogCategory } = await this.$post(
        updateCatalogCategoryMutation,
        {
          id: this.$route.params.id,
          name,
          isActive,
          sort: Number(sort) || 0,
          parentId: parentId ?? null,
          forNotice,
          productCategoryIds: linkedProductCategoryIds,
        },
        {
          delaySuccessNotify: true,
        }
      );

      if (updateCatalogCategory.id) {
        this.refreshCatalogCategories();
        this.$router.back();
      }
    },

    onClickDeleteButton() {
      this.isShownDeleteModal = true;
    },
  },
};
</script>
